import { useSite } from "@/contexts/SiteContext";
import Method from "@/components/sections/Method";
import SectionStyles from "@/components/sections/SectionStyles";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import SectionCta from "@/components/SectionCta";

export default function About() {
  const { sectionContent } = useSite();
  const c = sectionContent("about") || {};
  const ct = sectionContent("about_training") || {};
  const cc = sectionContent("about_cta") || {};
  const cm = sectionContent("method") || {};
  const storyParagraphs = Array.isArray(c.story_paragraphs) ? c.story_paragraphs : [];

  return (
    <div data-testid="about-page">
      <SectionStyles scopeKey="about" content={c} />
      <section data-section-key="about" data-section-self data-section-title="Despre Cristian (cuprins editabil)" className="relative pt-12 lg:pt-16 pb-20 lg:pb-28 hero-glow overflow-hidden" style={{ background: "var(--ct-bg)" }}>
        <div className="grain absolute inset-0 opacity-60 pointer-events-none" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
          <div className="mb-6"><Breadcrumbs items={[{ label: "Despre mine" }]} /></div>
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden" style={{ border: "1px solid var(--ct-border)" }}>
              <img
                src={c.image_url || "data:image/svg+xml;utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20400%20500'%3E%3Crect%20width='400'%20height='500'%20fill='%23e8e2d6'/%3E%3Cg%20fill='%23c4bba9'%3E%3Ccircle%20cx='200'%20cy='190'%20r='70'/%3E%3Cpath%20d='M80%20470c0-75%2054-130%20120-130s120%2055%20120%20130z'/%3E%3C/g%3E%3C/svg%3E"}
                alt={c.image_url ? "Terapeut Cristian" : "Fotografie în curând"}
                data-img="image_url"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7 space-y-6">
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Despre Terapeut Cristian"}</span>
            <h1 data-el="title" data-field="title" className="font-serif text-5xl sm:text-6xl leading-[0.95]" style={{ whiteSpace: "pre-line" }}>
              {c.title || (<>Un drum de la durere la <em className="italic" style={{ color: "var(--ct-gold)" }}>claritate</em>.</>)}
            </h1>
            {c.lead && (
              <p data-el="lead" data-field="lead" className="text-lg italic font-serif leading-relaxed" style={{ color: "var(--ct-text)" }}>{c.lead}</p>
            )}
            {c.body && (
              <p data-el="body" data-field="body" className="text-base leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{c.body}</p>
            )}
          </div>
        </div>
        {storyParagraphs.length > 0 && (
          <div className="max-w-3xl mx-auto mt-14 lg:mt-20 space-y-6" data-testid="about-story">
            {storyParagraphs.map((p, i) => (
              <p key={i} data-el="item_body" data-field={`story_paragraphs.${i}`} className="text-base sm:text-lg leading-loose" style={{ color: "var(--ct-text)" }}>
                {p}
              </p>
            ))}
          </div>
        )}
        </div>
      </section>

      <div data-section-key="about_training" data-section-title="Despre — Formare & practici">
        <SectionStyles scopeKey="about_training" content={ct} />
        <section className="py-20 lg:py-28" style={{ background: "var(--ct-surface)" }}>
          <div className="max-w-5xl mx-auto px-5 lg:px-8 space-y-12">
            <div>
              <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{ct.eyebrow || "Ce am studiat și practic"}</span>
              <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3">{ct.title || "Formare și practici"}</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-5">
              {[
                { t: ct.card1_title || "Lucrul cu subconștientul", d: ct.card1_desc || "Reprogramarea convingerilor profunde care îți modelează reacțiile și viața de zi cu zi.", tf: "card1_title", df: "card1_desc" },
                { t: ct.card2_title || "Curățare energetică", d: ct.card2_desc || "Eliberarea blocajelor și a energiilor stagnante care îți limitează claritatea și vitalitatea.", tf: "card2_title", df: "card2_desc" },
                { t: ct.card3_title || "Activarea centrilor subtili", d: ct.card3_desc || "Echilibrarea centrilor energetici ai corpului pentru un flux natural al energiei.", tf: "card3_title", df: "card3_desc" },
                { t: ct.card4_title || "Reprogramare mentală", d: ct.card4_desc || "Lucru direct cu structura mentală pentru un răspuns interior nou.", tf: "card4_title", df: "card4_desc" },
                { t: ct.card5_title || "Lucru emoțional", d: ct.card5_desc || "Aducere la suprafață și eliberare a încărcăturii nerezolvate.", tf: "card5_title", df: "card5_desc" },
                { t: ct.card6_title || "Ghidare spirituală", d: ct.card6_desc || "Conectare la sine și la sensul propriu, dincolo de tipare.", tf: "card6_title", df: "card6_desc" },
              ].map((p, i) => (
                <div key={i} className="card-premium p-7" data-testid={`practice-${i}`}>
                  <h3 data-el="item_title" data-field={p.tf} className="font-serif text-xl mb-2">{p.t}</h3>
                  <p data-el="item_body" data-field={p.df} className="text-sm leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{p.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <div data-section-key="method" data-section-title="Cum lucrez — metoda">
        <SectionStyles scopeKey="method" content={cm} />
        <Method />
      </div>

      <div data-section-key="about_cta" data-section-title="Despre — CTA final">
        <SectionStyles scopeKey="about_cta" content={cc} />
        <section className="py-20 text-center" style={{ background: "var(--ct-bg)" }}>
          <div className="max-w-2xl mx-auto px-5">
            <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mb-4">{cc.title || "Vrei să lucrăm împreună?"}</h2>
            <p data-el="subtitle" data-field="subtitle" className="text-base mb-7" style={{ color: "var(--ct-text-muted)" }}>
              {cc.subtitle || "Începem cu o discuție în care simțim împreună dacă suntem o potrivire."}
            </p>
            <SectionCta
              content={cc}
              prefix="cta"
              fallbackText="Programează o discuție"
              fallbackLink="/programare"
              className="btn-gold"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
